import request from '@/utils/request'

export function list(query) {
    return request({
        url: '/order/union/list',
        method: 'get',
        params: query
    })
}

export function info(id) {
    return request({
        url: '/order/union/info/' + id,
        method: 'get'
    })
}

export function save(data) {
    return request({
        url: '/order/union/save',
        method: 'post',
        data
    })
}

export function update(data) {
    return request({
        url: '/order/union/update',
        method: 'post',
        data
    })
}

export function remove(data) {
    return request({
        url: '/order/union/delete',
        method: 'post',
        data
    })
}

